import { useEffect, useState } from 'react';
import { customerService } from '../services/customerService';
import type { CustomerProfile } from '../types/customer.types';

export function useCurrentCustomer() {
  const [data, setData] = useState<CustomerProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    customerService
      .getCurrent()
      .then((c) => {
        if (!cancelled) setData(c);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof Error ? err : new Error(String(err)));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { data, isLoading, error };
}
